(() => {
  if (window.boxCrazeSectionMotion) return;
  window.boxCrazeSectionMotion = true;
  const regions = new Map();
  const active = new Set();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let enabled = !reduced.matches;
  let frame = 0;
  let previousTime = null;
  let width = innerWidth;
  let height = innerHeight;
  const canvas = document.createElement('canvas');
  canvas.className = 'bc-movable-motion-canvas';
  canvas.id = 'bc-movable-motion-canvas';
  canvas.setAttribute('aria-hidden', 'true');
  const context = canvas.getContext('2d');
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'bc-movable-motion';
  button.hidden = true;
  button.setAttribute('aria-controls', canvas.id);
  function schedule() {
    if (!frame && context) frame = requestAnimationFrame(draw);
  }
  function refresh() {
    const paused = !enabled || reduced.matches || document.hidden;
    regions.forEach((state, node) => node.toggleAttribute('data-motion-paused', paused));
    const first = [...active].find(node => regions.get(node)?.motion);
    button.hidden = !first || reduced.matches || document.hidden;
    if (first) {
      button.textContent = enabled ? first.dataset.motionPause : first.dataset.motionResume;
      button.setAttribute('aria-label', first.dataset.motionLabel);
    }
    button.setAttribute('aria-pressed', String(enabled));
    schedule();
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) active.add(entry.target);
      else active.delete(entry.target);
    });
    refresh();
  });
  function scan() {
    regions.forEach((state, node) => {
      if (!node.isConnected) {
        observer.unobserve(node);
        active.delete(node);
        regions.delete(node);
      }
    });
    document.querySelectorAll('[data-bc-motion-region]').forEach(node => {
      if (regions.has(node)) return;
      const prefix = node.dataset.family === 'pages' ? '--bcp-' : '--bc-';
      const style = getComputedStyle(node);
      const colors = ['pink', 'aqua', 'purple', 'yellow'].map(color => style.getPropertyValue(prefix + color).trim());
      const count = Math.max(10, Math.min(60, Number(node.dataset.density) || 22));
      const sprinkles = node.dataset.sprinkles === 'true';
      regions.set(node, {
        sprinkles,
        motion: sprinkles || !!node.querySelector('.bc-ribbon--moving,.bcp-ribbon--moving,.bc-sticker,.bcp-sticker,.bcp-faq-sticker'),
        speed: Number(node.dataset.fallSpeed) || 2,
        travel: 0,
        particles: Array.from({ length: count }, (_, i) => ({
          x: (i * .6180339887 + .17) % 1,
          y: (i * .4142135623 + .09) % 1,
          size: 6 + i % 5,
          angle: i * 1.47,
          speed: .35 + (i % 7) * .075,
          color: colors[i % 4]
        }))
      });
      observer.observe(node);
    });
    refresh();
  }
  function draw(time) {
    frame = 0;
    context.clearRect(0, 0, width, height);
    if (!enabled || reduced.matches || document.hidden || active.size === 0) {
      previousTime = null;
      return;
    }
    const elapsed = previousTime === null ? 0 : Math.min((time - previousTime) / 1000, .05);
    previousTime = time;
    let animate = false;
    active.forEach(node => {
      const state = regions.get(node);
      if (!state?.sprinkles) return;
      const rect = node.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= height) return;
      animate = true;
      state.travel += elapsed * 30 * state.speed;
      const top = Math.max(0, rect.top);
      const bottom = Math.min(height, rect.bottom);
      context.save();
      context.beginPath();
      context.rect(0, top, width, bottom - top);
      context.clip();
      const particles = width < 700 ? state.particles.slice(0, Math.ceil(state.particles.length * .6)) : state.particles;
      particles.forEach(p => {
        const lane = p.x < .5 ? p.x * .2 : .90 + (p.x - .5) * .2;
        const x = lane * width + Math.sin(state.travel * .002 + p.angle) * 12;
        const y = ((p.y * (height + 40) + state.travel * p.speed) % (height + 40)) - 20;
        context.save();
        context.translate(x, y);
        context.rotate(p.angle + state.travel * .002);
        context.globalAlpha = .65;
        context.strokeStyle = p.color;
        context.lineWidth = 4;
        context.lineCap = 'round';
        context.beginPath();
        context.moveTo(-p.size / 2, 0);
        context.lineTo(p.size / 2, 0);
        context.stroke();
        context.restore();
      });
      context.restore();
    });
    if (animate) schedule();
    else previousTime = null;
  }
  function resize() {
    width = innerWidth;
    height = innerHeight;
    const ratio = Math.min(devicePixelRatio || 1, 2);
    canvas.width = Math.round(width * ratio);
    canvas.height = Math.round(height * ratio);
    context?.setTransform(ratio, 0, 0, ratio, 0, 0);
    schedule();
  }
  function start() {
    document.body.append(canvas, button);
    scan();
    resize();
  }
  button.addEventListener('click', () => { enabled = !enabled; refresh(); });
  reduced.addEventListener('change', () => { enabled = !reduced.matches; refresh(); });
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('resize', resize, { passive: true });
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(event => document.addEventListener(event, scan));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
